import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { FillsGraphData } from 'widgets/fillsGraph/fillsGraphData';
import { findBucket } from 'widgets/fillsGraph/fillsGraphDataBuckets';
import FillsChartToggleLegend from 'widgets/fillsGraph/legend/FillsChartToggleLegend';
import { FillsChartType } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import { actualVolumeLabel, expectedVolumeLabel } from '../legend/labels';
import ExpectedVsActualHelp from './help/ExpectedVsActualHelp';
import {
    actualVolumeTooltip,
    expectedVolumeTooltip,
} from './help/expectedVsActualLegendTooltips';
import { CollapseCompanionChartToggleButton } from 'widgets/fillsGraph/collapsableCompanionCharts/CollapseCompanionChartToggleButton';
import { useLegendStatus } from 'widgets/fillsGraph/legendStatus';
import { FillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';

interface ExpectedVsActualChartLegendProps {
    fillsGraphData: FillsGraphData;
    fillsGraphPortfolioData: FillsGraphPortfolioData;
    fillsGraphContainerLeft: number;
}

export default function ExpectedVsActualChartLegend(
    props: ExpectedVsActualChartLegendProps
) {
    const { fillsGraphData, fillsGraphPortfolioData, fillsGraphContainerLeft } =
        props;
    const time = usePointedTime('ExpectedVsActualChartLegend');
    const { data, timeCompleted, volumesArePercentages } = fillsGraphData;
    const { numberFormat } = useContext(AppContext);

    const bucket = findBucket(data, time || timeCompleted);

    const valueSuffix = volumesArePercentages ? '%' : '';

    const expectedVolume = bucket
        ? numberFormat.n0(bucket.expectedVolume) + valueSuffix
        : undefined;
    const actualVolume = bucket
        ? numberFormat.n0(bucket.actualVolume) + valueSuffix
        : undefined;

    const { allExpectedVsActualHidden: allHidden } = useLegendStatus(
        fillsGraphData,
        fillsGraphPortfolioData
    );

    if (allHidden) {
        return <></>;
    }

    return (
        <div className="ExpectedVsActualChartLegend">
            <FillsChartToggleLegend
                className={`volume-expected`}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                label={expectedVolumeLabel}
                value={expectedVolume}
                chart={FillsChartType.ExpectedVsActual}
                property={'displayExpected'}
                hideLegendProperty={'hideExpectedLegend'}
                tooltip={expectedVolumeTooltip}
            />
            <FillsChartToggleLegend
                className={`volume-actual`}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                label={actualVolumeLabel}
                value={actualVolume}
                chart={FillsChartType.ExpectedVsActual}
                property={'displayActual'}
                hideLegendProperty={'hideActualLegend'}
                tooltip={actualVolumeTooltip}
            />
            <ExpectedVsActualHelp />
            <CollapseCompanionChartToggleButton
                section={FillsChartType.ExpectedVsActual}
            />
        </div>
    );
}
